// project-imports
import { getRequest, postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - COMMERCIAL (PORTAL) ||============================== //

export async function handleCommercial(action: APIAction) {
  switch (action.method) {
    case 'read':
      return getRequest(`/portal/commercial/${action.id}`);
    case 'create-update':
      return postRequest('/portal/commercial', action.data);
    default:
      console.info('[ApiManager > handleApiAction > handleCommercial] - Unknown method');
      break;
  }
}
